import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { cleanJoin } from "../../../../utils/stringUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { MessageContext } from "../../../../common/message/MessageContext";
import { publish } from "../../../../eventBus";
import { STEPS } from "../steps/Steps";
import { InfoBarContext } from "../../../../common/info";
import PdfFormErrors from "../pdf/PdfFormErrors";

function Next({ display, disabled, label }) {
  const { state, dispatch } = useContext(RequestSubmissionContext);
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const infoBar = useContext(InfoBarContext);

  const { PDF_FORM, UPLOAD } = STEPS;

  const [attachments, setAttachments] = useState(null);
  const [documentsAreValid, setDocumentsAreValid] = useState(false);

  useEffect(() => {
    const numOfAttachments = state.upload.documents.length;
    let attachmentsAreValid = true;

    // Validation for attached documents
    // Validation for not required documents could be added here
    state.upload.documents.forEach((doc) => {
      if (doc.label.length > 0 && doc.required === true && doc.uploadStatus !== 4) {
        attachmentsAreValid = false;
      }
    });
    // Disable next step if validation is invalid
    if (numOfAttachments > 0 && attachmentsAreValid) {
      setAttachments(numOfAttachments);
      setDocumentsAreValid(true);
    } else if (!attachmentsAreValid) {
      setAttachments(0);
      setDocumentsAreValid(false);
    }
  }, [state.upload.documents]);

  const next = (e) => {
    switch (state.activeStepIndex) {
      case PDF_FORM:
        publish({
          type: "validate-pdf-form",
          payload: {},
          onReturn: (validationErrors) => {
            if (validationErrors.length === 0) {
              dispatch({ type: "next" });
            } else {
              if (!infoBar.isOpen) {
                infoBar.toggle(
                  t("requests.submission.pdf.pdfFormErrorInfo.errorMessageTitle"),
                  () => <PdfFormErrors errors={JSON.stringify(validationErrors)} />
                );
              }
            }
          },
        });
        break;
      case UPLOAD:
        publish({
          type: "validate-document-upload",
          payload: {},
          onReturn: (validationResult) => {
            if (validationResult.valid) {
              documentsAreValid
                ? dispatch({ type: "next" })
                : attachments === null && state.upload.documents.length === 0
                ? dispatch({ type: "next" })
                : message.toggle({
                    title: t("modalMessage.titleInfo"),
                    content: validationResult.message,
                    yesLabel: t("modalMessage.okLabel"),
                    onYes: () => message.toggle({}),
                    hideNo: true,
                  });
            }
          },
        });
        break;
      default:
        dispatch({ type: "next" });
    }
    e.currentTarget.blur();
  };

  return display ? (
    <button
      disabled={disabled}
      onClick={next}
      className={cleanJoin(
        "button",
        "pdf-form-action-button",
        "no-focus-outline",
        "has-border-yellow-1",
        display
          ? disabled
            ? ""
            : "has-background-warning-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          : ""
      )}
    >
      {label}
    </button>
  ) : null;
}

export default Next;
